import Text from "@gcs/design-system/react/components/Text";
import * as S from "./BaseBoard.style";

const BaseBoard = ({ title, description, button, onClick }) => {
  return (
    <S.ContainerBaseBoard>
      <Text variant="headline-02">{title}</Text>
      <p>{description}</p>
      <S.ActionButton onClick={onClick}>{button}</S.ActionButton>
    </S.ContainerBaseBoard>
  );
};

export default BaseBoard;
